export default {
  index: {
    text1: "邀請",
    text2: "資產",
    text3: "賬單",
    text4: "專區",
    text5: "一星公約",
    text6: "認購",
    text7: "二星公約",
    text8: "簡介",
    text9: "加入我們社區",
    text10: "綁定上級",
    text11: "請輸入推薦人地址",
    text12: "確定",
    text13: "貢獻激勵池",
    text14: "獎勵剩餘",
    text15: "待開放",
	text16: "合作伙伴",
  },
  wallet: {
    text1: "資產總估值",
    text2: "賬單",
    text3: "餘額",
    text4: "轉出",
    text5: "白名單權益",
    text6: "IDO權益",
    text7: "認購",
	text8: "兑换",
	},
	dui :{
		text1: "兑换白名单权益",
	},
  pawn: {
    text1: "收益次日18:18結算，日化收益中70%結算為USDT，30%結算為相應等值的UES代幣，UES市場價值為3U。",
    text2: "認購",
    text3: "枚",
    text4: "一星公約",
    text5: "每日收益",
    text6: "二星公約",
    text7: "三星公約",
    text8: "Plus公約"
  },
  zy: {
    text1: "收益中",
    text2: "已到期",
    text3: "數量",
    text5: "已收益",
    text4: "認購日期"
  },
  team: {
    text1: "當前等級",
    text2: "我的認購",
    text3: "小區業績",
    text4: "我的推薦人",
    text5: "推薦人的認購",
    text6: "我的團隊",
    text7: "業績總和",
    text8: "小區業績",
    text9: "團隊人數",
    text10: "我的推薦",
    text11: "認購數量",
    text12: "邀請鏈接"
  },
  withdrawal: {
    text1: "提現數量",
    text2: "到賬",
    text3: "手續費",
    text4: "錢包餘額",
    text5: "轉出凍結",
    text6: "確定",
    text7: "請輸入轉出數量"
  },
  record: {
    text1: "類型",
    text2: "數量",
    text3: "時間"
  },
  header: {
    text1: '更多',
    text2: '推薦鏈接',
    text3: '首頁',
    text4: '錢包',
    text5: '認購',
    text6: '我的公約',
    text7: '我的團隊',
	text8: 'RLP白名单',
  },
  lan: {
    text1: '英語',
    text2: '簡體',
    text3: '繁體',
    text4: '泰語',
    text5: '韓語',
    text6: '日語',
    text7: '越南語'
  },
  tost: {
    text1: '待開放',
    text2: '請輸入提幣數量',
    text3: '餘額不足',
    text4: '複製成功',
	text5: '至少轉出 50 USDT',
  },
  rlp: {
  	 text10: "RLP認購",
  	    text1: "白名單100額度可認購0.1BNB",
  	    text2: "認購",
  	    text4: "認購定價",
  	    text3: "100額度/0.1BNB",
  	    text5: "BNB",
  	    text6: "我的白名單",
  	    text7: "認購"
  	
  },
}